import { StopArea } from '../models/stopArea';

export function getDisplayName(stopArea: StopArea): string {
  return `${stopArea.name} (${stopArea.municipality})`; // Format need to be in sync with backend display name
}
